export interface ListDTO {
    id: number;
    userId: number,
    calendarId: number,
    calendar: String,
    calendarIntegrationId: number,
    description: string,
    isShared: boolean
}

export interface ListWriteDTO {
    userId: number,
    calendarId: number,
    description: string
}

export interface SharedListMemberDTO {
    listId: number;
    emailAddress: string;
}

export function createList(userId: number,
    calendarId: number,
    description: string) {
    return {
        userId: userId, calendarId: calendarId, description: description
    }
}